import React from 'react'

import { randomColor } from '../../../utils/randomColor'
import { toTitleCase } from '../../../utils/toTitleCase'

function StudentCard({ ktu_rollno, name }) {
  return (
    <div className='studentCard' data-aos="fade-up">
        <div className='student__avatar' style={{ background: randomColor(ktu_rollno)}}>{name[0]}</div>
        <div className='student__detils'>
            <h1>{toTitleCase(name)}</h1>
            <p>{ktu_rollno}</p>
        </div>
    </div>
  )
}

export default StudentCard